import React from 'react';
import { useState, useEffect } from 'react';
// material
import {
    Table,
    TableBody,
    TableContainer,
    Pagination,
    Box,
    Typography,
    TableCell,
    TableRow
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CommonTableHead from '../../foodVendor/reports/commonTableHead.js';
import Scrollbar from '../../Scrollbar';
import { getKioskMenuListWatcher } from '../../../redux/actionCreators/kiosk';
import MenuListTableRow from './tableRow';

export const TABLE_HEAD = [
    { id: 'MealName', label: 'Meal Name', alignRight: false, title: 'Meal Name', field: 'cMealName' },
    { id: 'MenuName', label: 'Menu Code', alignRight: false, title: 'Menu Code', field: 'cMenuName' },
    { id: 'ctype', label: 'Meal Type', alignRight: false, title: 'Meal Type', field: 'ctype' },
    { id: 'MenuDesc', label: 'Menu Description', alignRight: false, title: 'Menu Description', field: 'cMenuDesc' },
    { id: 'TotalRate', label: 'Total Rate', alignRight: false, title: 'Total Rate', field: 'nTotalRate' },
    { id: 'bIsActive', label: 'Status', alignRight: false, title: 'Status', field: 'bIsActive' },
    // { id: 'action', label: 'Action', alignRight: false },
];


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const MenuListTable = ({ searchVal, searchText, page, setPage  }) => {

    const { KioskRoleReducers: { kioskMenuList } } = useSelector((state) => state)

    let firstIndex = 0;

    const dispatch = useDispatch();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [action] = useState(true);
    const [rowsPerPage] = useState(5);

    useEffect(() => {
        let data = {
            "ACTION": "getKioskMenuList"
        }
        dispatch(getKioskMenuListWatcher(data))
    }, [dispatch])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const tableData = searchText ? searchVal : kioskMenuList
    const filteredData = applySortFilter(tableData, getComparator(order, orderBy));
    const isUserNotFound = filteredData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{overflow:'unset'}} >
                        <Table>
                            <CommonTableHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                action={action}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                {filteredData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    .map((f, i) => {
                                        return (
                                            <MenuListTableRow key={i} rowData={f} index={i} />
                                        )
                                    })}
                            </TableBody>
                            {isUserNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(tableData?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default MenuListTable;